import React from 'react';
import { Row } from '../layout/GridSystem/Row';
import styled from 'styled-components/macro';
import Headline3 from '../typography/Headline3';
import LabelLight from '../typography/LabelLight';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { useDateTimeFormatSetting } from '@fides/fides-react-components';
import { CASHPOOL_MODULE_ID } from "../../constants/constant";

type Props = {
    document: any;
}
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding-top: 8px;
  width: 49%;
  border-bottom: 1px solid #9b9ea1;
`;

const LabelContainer = styled.span`
  margin-bottom: 8px
`;

const ViewReportDetailsForm = (props: Props) => {
    const { t } = useTranslation();
    const { document } = props;
    const dateTimeFormat = useDateTimeFormatSetting();
    const isCashPoolType = document?.owner1Type?.toLowerCase() === CASHPOOL_MODULE_ID.toLowerCase();

    return (
        <div>
            <Row>
                <Container>
                    <LabelContainer><LabelLight>{t("document.documentOwner1")}</LabelLight></LabelContainer>
                    <Headline3>{isCashPoolType && t('ownerType.' + document.owner1Type) + ' '}{document.owner1}</Headline3>
                </Container>
                <Container>
                    <LabelContainer><LabelLight>{t("document.documentOwner2")}</LabelLight></LabelContainer>
                    <Headline3>{isCashPoolType && document?.owner2Type ? t('ownerType.' + document?.owner2Type) + ' ' : ''}{document?.owner2 ?? ' '}</Headline3>
                </Container>
            </Row>
            <Row>
                <Container>
                    <LabelContainer><LabelLight>{t("document.createdOn")}</LabelLight></LabelContainer>
                    <Headline3>{document.creationDate ? format(new Date(document.creationDate), dateTimeFormat) : ""}</Headline3>
                </Container>
                <Container>
                    <LabelContainer><LabelLight>{t("document.createdBy")}</LabelLight></LabelContainer>
                    <Headline3>{document.creatorUsername}</Headline3>
                </Container>
            </Row>
        </div>
    )
}

export default ViewReportDetailsForm;